import { post } from "./base";
import { phoneReg } from "../common/js/phone_number_check";

export function userLogin(phoneNum, verifyCode) {
    if (phoneReg.test(phoneNum) == false) {
        alert("请输入正确的手机号");
        return false;
    }
    return post('/account/loginByMobile',{
        mobile: phoneNum,
        code: verifyCode
    });
}

export function orgLogin(phoneNum, verifyCode) {
    if (phoneReg.test(phoneNum) == false) {
        alert("请输入正确的手机号");
        return false;
    }
    return post('/org/loginorg',{
        mobile: phoneNum,
        code: verifyCode
    });
}
